import { CopyMetadataFromParent, Property } from '@skylab-shared/core';
import { SaleDocumentItemModel } from './sale-document-item.model';

@CopyMetadataFromParent()
export class SaleAdvanceDocumentItemModel extends SaleDocumentItemModel {
    @Property()
    public advance: number;
}
